<ng-container *ngIf="role === 'system_admin'; else readonlyBadge">
  <button class="tenant-badge tenant-badge--clickable" (click)="openSwitcher()" title="Switch tenant">
    <i class="pi pi-building"></i>
    <span class="tenant-badge__name">{{ displayName }}</span>
    <i class="pi pi-arrows-h tenant-badge__swap-icon"></i>
  </button>
</ng-container>

<ng-template #readonlyBadge>
  <span class="tenant-badge tenant-badge--readonly" *ngIf="role">
    <i class="pi pi-building"></i>
    <span class="tenant-badge__name">{{ displayName }}</span>
  </span>
</ng-template>

<p-dialog
  [(visible)]="showSwitcher"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  header="Switch Tenant"
  styleClass="tenant-switcher-dialog"
  [style]="{ width: '360px' }"
>
  <div class="tenant-switcher">
    <div class="tenant-switcher__search">
      <span class="p-input-icon-left w-full">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          placeholder="Search tenants..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearch()"
          class="w-full"
        />
      </span>
    </div>

    <div class="tenant-switcher__list-wrapper">
      <p-progressSpinner *ngIf="loading" styleClass="tenant-switcher__spinner"></p-progressSpinner>

      <p-scrollPanel *ngIf="!loading" styleClass="tenant-switcher__scroll" [style]="{ height: '280px' }">
        <div class="tenant-switcher__list">
          <button
            *ngFor="let tenant of filteredTenants"
            class="tenant-switcher__item"
            [class.tenant-switcher__item--active]="tenant.tenantId === tenantContextService.selectedTenantId()"
            (click)="selectTenant(tenant)"
          >
            <span class="tenant-switcher__item-name">{{ tenant.name }}</span>
            <span *ngIf="tenant.tradingAs" class="tenant-switcher__item-trading">
              t/a {{ tenant.tradingAs }}
            </span>
            <span
              class="tenant-switcher__item-status"
              [class.tenant-switcher__item-status--inactive]="tenant.status === 'INACTIVE'"
            >
              {{ tenant.status }}
            </span>
          </button>

          <p *ngIf="filteredTenants.length === 0" class="tenant-switcher__empty">
            No tenants found.
          </p>
        </div>
      </p-scrollPanel>
    </div>
  </div>
</p-dialog>
